const translate = {
    install (Vue) {
        Vue.prototype.$_t = function (msg, params) {
            return this.$t(msg, params)
        }
    }
}

export default translate
